import { FC } from 'react';
import clsx from 'clsx';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { Props } from './types';

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  radioWrapper: {
    display: 'flex',
    cursor: 'pointer',
    marginTop: spacing(2)
  },
  outerCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: `2px solid ${palette.primary.light}`,
    marginRight: spacing(2)
  },
  innerCircle: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: palette.success.main
  },
  active: {
    borderColor: palette.success.main
  }
}));

const RadioGroup: FC<Props> = ({ data, selectedValue, onChange }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {data.map(({ text, value }) => (
        <Box
          key={value}
          className={classes.radioWrapper}
          onClick={() => onChange(value)}
        >
          <div
            className={clsx(
              classes.outerCircle,
              value === selectedValue && classes.active
            )}
          >
            {value === selectedValue && <div className={classes.innerCircle} />}
          </div>
          <Typography variant="body1" color="textPrimary">
            {text}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default RadioGroup;
